module.exports = __webpack_public_path__ + "img/share_ios.23b29d35.png";